import { Dropdown, Tab, Tabs } from "react-bootstrap";
import NotFoundComponent from "../../../NotFound/NotFoundComponent";
import { useTranslation } from "react-i18next";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { useEffect, useState, useCallback, useRef } from "react";
import _ from "lodash";
import {
  getCoachingListing,
  getCoachingListingClear,
  getCoachingPersonalListing,
  getCoachingPersonalListingClear,
} from "../../../../../redux/coaching/actions";
import CONFIG from "../../../../../utils/config";
import API_LIST from "../../../../../utils/apiList";
import {
  getProcureInfo,
  ProductCardPriceInfo,
  SessionKeys,
} from "../../../../../utils/AppUtils";
import SlotBookingModal from "../SlotBookingModal";
import Rating from "@mui/material/Rating";
import Slider, { Range } from "rc-slider";
import "rc-slider/assets/index.css";
import ProductCardComponent from "../../../ProductCard/ProductCardComponent";
import ShimmerScreen from "../../../../Layouts/ShimmerScreen";
import { RightArrowIcon } from "../../../../../utils/SvgComps";

const CoachingListing = ({ isLoading, setIsLoading }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const observer = useRef();
  const coachingListingRes = useSelector(
    (state) => state.coaching.coachingListing
  );

  const coachingPersonalListingRes = useSelector(
    (state) => state.coaching.coachingPersonalListing
  );
  const [key, setKey] = useState("YourCoaches");
  const [coachList, setCoachList] = useState(CONFIG.INITIAL_PRODUCT_CARD_DATA);
  const [filtersData, setFiltersData] = useState([]);
  const [searchText, setSearchText] = useState("");
  const [debouncedText, setDebouncedText] = useState("");
  const [timeoutId, setTimeoutId] = useState(null);

  const [sessionModal, setSessionModal] = useState(false);
  const [selectedCoachId, setSelectedCoachId] = useState("");
  const [productTitle, setProductTitle] = useState("");
  const [productId, setProductId] = useState("");
  const [displayName, setDisplayName] = useState("");

  const [isFetching, setIsFetching] = useState(false);
  const [hasNoMore, setHasNoMore] = useState(true);
  const [totalRecords, setTotalRecords] = useState(0);
  const [pageSize, setPageSize] = useState(20);
  const [pageNum, setPageNum] = useState(1);

  // industry filter related states
  const [industrySearch, setIndustrySearch] = useState("");
  const [selectedIndustryItems, setSelectedIndustryItems] = useState([]);
  const [showIndustryDropdown, setShowIndustryDropdown] = useState(false);
  const [filteredIndustries, setFilteredIndustries] = useState([]);
  const [originalIndustries, setOriginalIndustries] = useState([]);

  //language filter related states
  const [languageSearch, setLanguageSearch] = useState("");
  const [selectedLanguageItems, setSelectedLanguageItems] = useState([]);
  const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
  const [filteredLanguages, setFilteredLanguages] = useState([]);
  const [originalLanguages, setOriginalLanguages] = useState([]);
  //country filter states
  const [countrySearch, setCountrySearch] = useState("");
  const [selectedCountryItems, setSelectedCountryItems] = useState([]);
  const [showCountryDropdown, setShowCountryDropdown] = useState(false);
  const [filteredCountries, setFilteredCountries] = useState([]);
  const [originalCountries, setOriginalCountries] = useState([]);

  //skills  filter states
  const [skillSearch, setSkillSearch] = useState("");
  const [selectedSkillItems, setSelectedSkillItems] = useState([]);
  const [showSkillDropdown, setShowSkillDropdown] = useState(false);
  const [filteredSkills, setFilteredSkills] = useState([]);
  const [originalSkills, setOriginalSkills] = useState([]);

  //rating filter states
  const [range, setRange] = useState([0, 5]); // Initial range values
  const [showRatingDropdown, setShowRatingDropdown] = useState(false);

  const search = window.location.search;
  const params = new URLSearchParams(search);

  const myCoaches = params.get("mycoaches");
  let industries = params.get("industries");
  let languages = params.get("languages");
  let countries = params.get("countries");
  let skills = params.get("skills");
  let rating = params.get("rating");

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  useEffect(() => {
    console.log("myCoaches", myCoaches);
    fetchPersonalCoachListing();
  }, [
    dispatch,
    industries,
    languages,
    countries,
    skills,
    rating,
    window.location.pathname,
  ]);

  useEffect(() => {
    fetchPersonalCoachListing();
  }, [pageNum]);

  const formatCoachCardData = (arrList) => {
    if (!_.isEmpty(arrList)) {
      let prodArr = [];
      for (let coach of arrList) {
        console.log("coach---", coach);
        let btnTitle = "";
        let priceInfo = getProcureInfo(coach?.purchased_info);
        coach.priceInfo = priceInfo;
        if (coach?.priceInfo?.isPurchased) {
          btnTitle = t("RequestForASession");
        } else {
          btnTitle = t("proceed");
        }

        prodArr.push({
          id: coach?.id,
          ecom_id: coach?.ecom_id ? coach?.ecom_id : coach?.wc_post_id,
          is_like: false,
          is_bookmark: false,
          is_wishlist: false,
          dbId: coach?.list_id,
          productType: "coach",
          productOrigin: coach?.origin,
          title: coach?.display_name,
          logoURL: coach?.provider?.provider_img
            ? coach?.provider?.provider_img
            : "",
          bannerURL: coach?.profile_image
            ? coach?.profile_image
            : "https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png",
          tagsArray: [],
          description: coach?.short_description,
          btnTitle: btnTitle,
          progress: coach?.crs_progress,
          showRating: true,
          ratings: coach?.ratings,
          skills: coach?.user_skill,
          showIndustry: !_.isEmpty(coach?.user_industry) ? true : false,
          industry: !_.isEmpty(coach?.user_industry)
            ? coach?.user_industry[0]
            : "",
          showExperience: !_.isEmpty(coach?.experience) ? true : false,
          experience: coach?.experience,
          btnAction: () => {
            if (coach?.priceInfo?.isPurchased) {
              setSelectedCoachId(coach?.user_id);
              setProductTitle(coach?.product_title);
              setProductId(coach?.product_id);
              setDisplayName(coach?.display_name);

              setSessionModal(true);
            } else {
              handleCoachDetailNavigate(coach?.user_id);
            }
          },
          descAction: {},
          bannerAction: () => {
            if (coach?.priceInfo?.isPurchased) {
              setSelectedCoachId(coach?.user_id);
              setProductTitle(coach?.product_title);
              setProductId(coach?.product_id);
              setDisplayName(coach?.display_name);

              setSessionModal(true);
            } else {
              handleCoachDetailNavigate(coach?.user_id);
            }
          },
          footerLineComp: !_.isEmpty(priceInfo)
            ? ProductCardPriceInfo(priceInfo.showText, priceInfo.textColor)
            : "",
          showHeader: true,
          showProviderIcon: false,
          showLikeMenu: false,
          showBody: true,
          showFooter: true,
          showProgress: false,
          cardClassName: "",
          rightBtnIcon: "/images/arrow-right.svg",
          leftBtnIcon: "",

          priceInfo,
          isBundle: false,
        });
      }
      return prodArr;
    }
  };

  useEffect(() => {
    if (!_.isEmpty(coachingPersonalListingRes)) {
      if (coachingPersonalListingRes?.status === "success") {
        console.log("coachingListingRes", coachingPersonalListingRes);
        const listData =
          coachingPersonalListingRes?.payload?.payload?.listing?.coaching;
        for (let coach of listData) {
          coach.priceInfo = getProcureInfo(coach.purchased_info);
        }

        let formattedCoachData = formatCoachCardData(listData);
        let newProdArr = formattedCoachData;
        if (pageNum > 1) {
          newProdArr = [...coachList, ...formatCoachCardData];
          console.log(newProdArr);
          setCoachList(newProdArr);
          setIsFetching(false);
        } else {
          setCoachList(formattedCoachData);
        }

        // setCourseCount(newProdArr.length);
        console.log(
          "recordsLength: ",
          coachingPersonalListingRes?.payload?.payload?.listing?.total_records
        );
        if (
          coachingPersonalListingRes?.payload?.payload?.listing
            ?.total_records === newProdArr?.length
        ) {
          setIsFetching(false);
          setHasNoMore(true);
        } else {
          setHasNoMore(false);
        }
        const filterData =
          coachingPersonalListingRes?.payload?.payload?.filters;
        setFiltersData(filterData);
        let industriesFilters = filterData?.industries;
        console.log("industries", industriesFilters);
        setOriginalIndustries(industriesFilters);
        setFilteredIndustries(industriesFilters);

        let languagesFilters = filterData?.languages;
        setOriginalLanguages(languagesFilters);
        setFilteredLanguages(languagesFilters);

        let countriesFilters = filterData?.countries;
        setOriginalCountries(countriesFilters);
        setFilteredCountries(countriesFilters);

        let skillsFilters = filterData?.skills;
        setOriginalSkills(skillsFilters);
        setFilteredSkills(skillsFilters);
      }
      setIsLoading(false);
      dispatch(getCoachingPersonalListingClear());
    }
  }, [coachingPersonalListingRes]);

  // const fetchAllCoachListing = (searchText) => {
  //   setIsLoading(true);
  //   dispatch(
  //     getCoachingListing({
  //       URL: `${CONFIG.API_URL_BROKER}/${API_LIST.ECOM_API.GET_COACHING_LISINT}`,
  //       method: "POST",
  //       payload: {
  //         token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
  //         type: "coaching",
  //         search: searchText,
  //         sort_by: "ASC",
  //         page: 1,
  //         page_size: 20,
  //       },
  //     })
  //   );
  // };

  const fetchPersonalCoachListing = (searchText, isEmptyRating) => {
    setCoachList(CONFIG.INITIAL_PRODUCT_CARD_DATA);
    if (isEmptyRating) {
      setRange([0, 5]);
    }
    setIsLoading(true);
    const decodedRange = decodeURIComponent(rating);
    console.log("range---", decodedRange, range);
    // const [min, max] = decodedRange.split("-").map(Number);
    let min = 0;
    let max = 5;
    if (decodedRange != null) {
      const rangeValues = decodedRange.split("-");

      if (rangeValues.length === 2) {
        min = isNaN(Number(rangeValues[0])) ? 0 : Number(rangeValues[0]);
        max = isNaN(Number(rangeValues[1])) ? 5 : Number(rangeValues[1]);
        setRange([min, max]);
      }
    }

    console.log("range---2", decodedRange, range);
    if (!_.isEmpty(skills)) {
      setSelectedSkillItems(decodeURIComponent(skills).split(","));
    }
    if (!_.isEmpty(languages)) {
      setSelectedLanguageItems(decodeURIComponent(languages).split(","));
    }
    if (!_.isEmpty(countries)) {
      setSelectedCountryItems(decodeURIComponent(countries).split(","));
    }
    if (!_.isEmpty(industries)) {
      setSelectedIndustryItems(decodeURIComponent(industries).split(","));
    }

    dispatch(
      getCoachingPersonalListing({
        module: "getCoachingPersonalListing",
        postData: {
          token: localStorage.getItem(SessionKeys.API_TOKEN_BROKER),
          type: "coach_personal",
          sort_by: "ASC",
          page: pageNum,
          page_size: pageSize,
          industry: _.isEmpty(industries)
            ? []
            : decodeURIComponent(industries).split(","),
          language: !_.isEmpty(languages)
            ? decodeURIComponent(languages).split(",")
            : [],
          country: !_.isEmpty(countries)
            ? decodeURIComponent(countries).split(",")
            : [],
          skill: !_.isEmpty(skills)
            ? decodeURIComponent(skills).split(",")
            : [],
          rating: isEmptyRating
            ? "0-5"
            : min || max
            ? `${min}-${max}`
            : `${range[0]}-${range[1]}`,

          search: searchText,
        },
      })
    );
  };

  const fetchAICoachListing = () => {
    alert("Feature under development");
  };

  const paginateCB = useCallback(
    (node) => {
      if (isFetching) return;

      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        console.log("pageNumhasNoMore ", isFetching, entries[0].isIntersecting);
        if (entries[0].isIntersecting && !hasNoMore) {
          setIsFetching(true);
          setHasNoMore(true);
          // console.log('End of file', totalRecords, lpListing.length, pageNum, isLoading, isFetching)
          setPageNum((pageNum) => pageNum + 1); //pageNum => pageNum + 1
          setCoachList([...coachList, ...CONFIG.INITIAL_PRODUCT_CARD_DATA]);
        }
      });

      if (node) observer.current.observe(node);
      console.log(node);
    },
    [hasNoMore]
  );

  const toggleIndustryDropdown = () => {
    setShowLanguageDropdown(false);
    setShowCountryDropdown(false);
    setShowSkillDropdown(false);
    setShowRatingDropdown(false);
    setShowIndustryDropdown((prev) => !prev);
  };

  const handleIndustrySearchChange = (e) => setIndustrySearch(e.target.value);

  useEffect(() => {
    setFilteredIndustries(
      originalIndustries?.filter((item) =>
        item?.name?.toLowerCase()?.includes(industrySearch?.toLowerCase())
      )
    );
  }, [industrySearch]);

  const handleIndustryCheckboxChange = (item) => {
    setSelectedIndustryItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleIndustryApply = () => {
    if (selectedIndustryItems.length > 0) {
      const params = new URLSearchParams(window.location.search);
      params.set(
        "industries",
        encodeURIComponent(selectedIndustryItems.join(","))
      );
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setIndustrySearch("");
    setShowIndustryDropdown(false);
  };

  const toggleLanguageDropdown = () => {
    setShowIndustryDropdown(false);
    setShowCountryDropdown(false);
    setShowSkillDropdown(false);
    setShowRatingDropdown(false);
    setShowLanguageDropdown((prev) => !prev);
  };

  const handleLanguageSearchChange = (e) => setLanguageSearch(e.target.value);

  useEffect(() => {
    setFilteredLanguages(
      originalLanguages?.filter((item) =>
        item?.display_name
          ?.toLowerCase()
          ?.includes(languageSearch?.toLowerCase())
      )
    );
  }, [languageSearch]);

  const handleLanguageCheckboxChange = (item) => {
    setSelectedLanguageItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleLanguageApply = () => {
    if (selectedLanguageItems.length > 0) {
      const params = new URLSearchParams(window.location.search);
      params.set(
        "languages",
        encodeURIComponent(selectedLanguageItems.join(","))
      );
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setLanguageSearch("");
    setShowLanguageDropdown(false);
  };

  const toggleCountryDropdown = () => {
    setShowIndustryDropdown(false);
    setShowLanguageDropdown(false);
    setShowSkillDropdown(false);
    setShowRatingDropdown(false);
    setShowCountryDropdown((prev) => !prev);
  };

  const handleCountrySearchChange = (e) => setCountrySearch(e.target.value);

  useEffect(() => {
    setFilteredCountries(
      originalCountries?.filter((item) =>
        item?.name?.toLowerCase()?.includes(countrySearch?.toLowerCase())
      )
    );
  }, [countrySearch]);

  const handleCountryCheckboxChange = (item) => {
    setSelectedCountryItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleCountryApply = () => {
    if (selectedCountryItems.length > 0) {
      const params = new URLSearchParams(window.location.search);
      params.set(
        "countries",
        encodeURIComponent(selectedCountryItems.join(","))
      );
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setCountrySearch("");
    setShowCountryDropdown(false);
  };

  const toggleSkillDropdown = () => {
    setShowIndustryDropdown(false);
    setShowLanguageDropdown(false);
    setShowCountryDropdown(false);
    setShowRatingDropdown(false);
    setShowSkillDropdown((prev) => !prev);
  };

  const handleSkillSearchChange = (e) => setSkillSearch(e.target.value);

  useEffect(() => {
    setFilteredSkills(
      originalSkills?.filter((item) =>
        item?.name?.toLowerCase()?.includes(skillSearch?.toLowerCase())
      )
    );
  }, [skillSearch]);

  const handleSkillCheckboxChange = (item) => {
    setSelectedSkillItems((prev) =>
      prev.includes(item) ? prev.filter((i) => i !== item) : [...prev, item]
    );
  };

  const handleSkillApply = () => {
    if (selectedSkillItems.length > 0) {
      const params = new URLSearchParams(window.location.search);
      params.set("skills", encodeURIComponent(selectedSkillItems.join(",")));
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setSkillSearch("");
    setShowSkillDropdown(false);
  };

  const toggleRatingDropdown = () => {
    setShowIndustryDropdown(false);
    setShowLanguageDropdown(false);
    setShowSkillDropdown(false);
    setShowCountryDropdown(false);
    setShowRatingDropdown((prev) => !prev);
  };

  const handleRangeChange = (value) => {
    console.log("range---value", value);
    setRange(value); // Update the range state dynamically
  };

  const handleRatingApply = () => {
    if (!_.isEmpty(range)) {
      const params = new URLSearchParams(window.location.search);
      params.set("rating", encodeURIComponent(`${range[0]}-${range[1]}`));
      window.history.replaceState(
        {},
        "",
        `${window.location.pathname}?${params.toString()}`
      );
    } else {
      alert("No filters selected! Please select at least one.");
    }
    setRange([0, 5]);
    setShowRatingDropdown(false);
  };

  const handleCoachDetailNavigate = (coach_id) => {
    let paramsReq = {
      coach_id: coach_id,
    };
    let jsonString = JSON.stringify(paramsReq);
    let encodedUrl = btoa(jsonString);
    navigate(`/coach/detail?c=${encodedUrl}`);
  };

  const handleResetAllFilters = () => {
    const url = new URL(window.location.href);
    url.search = "";

    window.history.pushState({}, "", url.href);
    industries = [];
    rating = [];
    skills = [];
    countries = [];
    languages = [];
    setSelectedCountryItems([]);
    setSelectedIndustryItems([]);
    setSelectedLanguageItems([]);
    setSelectedSkillItems([]);
    setShowCountryDropdown(false);
    setShowIndustryDropdown(false);
    setShowLanguageDropdown(false);
    setShowRatingDropdown(false);
    setShowSkillDropdown(false);
    fetchPersonalCoachListing("", true);
  };

  useEffect(() => {
    console.log("range----useeffect", range, range[0], range[1]);
  }, [range]);

  const [formattedListing, setFormattedListing] = useState([
    {
      id: "4014",
      is_like: false,
      is_bookmark: false,
      productType: "Selling energie", //"Selling an Energy Solution",
      is_wishlist: false,
      productOrigin: "xsel",
      title: "Selling energie", //"Selling an Energy Solution",
      logoURL:
        "https://cdnstg.training.com/halifax/image/8e30b7d1-7cdd-4acc-bc5f-d423714b9d8f.png",
      logoAltText: "RP",
      bannerURL:
        "https://cdn-stg.niit-mts.com/xsel/image/045d8e5d-cd34-4556-a7d8-f3f29b94f709.png",
      // "https://cdnstg.training.com/halifax/image/b48f3c8e-021c-4d54-801b-d81fb2d84670.jpg",
      tagsArray: ["Halifax", "Role play"],
      description:
        "AI-enabled coach offers dynamic, interactive experiences where the AI adapts to various characters, scenarios, and dialogues, creating immersive, personalized storytelling that responds to user actions and choices in real-time.",
      duration: "",
      showHeader: true,
      showProviderIcon: true,
      showLikeMenu: false,
      showSubmitAndReview: false,
      showSubmittedBy: false,
      submittedBy: "",
      submittedOn: "Sep 5, 2024",
      showReviewedBy: false,
      feedbackStatus: false,
      reviewedBy: "1",
      reviewedOn: "Sep 5, 2024",
      showProgres: true,
      showBody: true,
      showFooter: true,
      btnTitle: "Explore",
      cardClassName: "",
      footerLineComp: "",
      btnAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=repower` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=repower`,
          "_blank"
        );
      },
      descAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=repower`
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=repower`,
          "_blank"
        );
      },
      bannerAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=repower`
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=repower`,
          "_blank"
        );
      },
      priceInfo: {
        isFree: true,
        isPurchased: false,
        isAddToCart: false,
        isOffer: "",
        price: 0,
        offerPrice: 0,
        showText: "",
        textColor: "#292D32",
        teaserViewed: false,
        teaserAccessed: false,
      },
      isLoading: false,
      rightBtnIcon: <RightArrowIcon />,
      leftBtnIcon: "",
    },
    {
      id: "4015",
      is_like: false,
      is_bookmark: false,
      productType: "Selling pharma", // "Selling a Pharma",
      is_wishlist: false,
      productOrigin: "xsel",
      title: "Selling pharma", //"Selling a Pharma",
      logoURL:
        "https://cdnstg.training.com/halifax/image/8e30b7d1-7cdd-4acc-bc5f-d423714b9d8f.png",
      logoAltText: "RP",
      bannerURL:
        "https://cdn-stg.niit-mts.com/xsel/image/02bfa59b-d37e-4e56-8f3d-3201e8645203.png",
      // "https://cdnstg.training.com/halifax/image/b6022eb7-fce0-48f2-98b3-c62abaa486ab.jpg",
      tagsArray: ["Halifax", "Role play"],
      description:
        "AI-enabled roleplay offers dynamic, interactive experiences where the AI adapts to various characters, scenarios, and dialogues, creating immersive, personalized storytelling that responds to user actions and choices in real-time.",
      duration: "",
      showHeader: true,
      showProviderIcon: true,
      showLikeMenu: false,
      showSubmitAndReview: false,
      showSubmittedBy: false,
      submittedBy: "",
      submittedOn: "Sep 5, 2024",
      showReviewedBy: false,
      feedbackStatus: false,
      reviewedBy: "1",
      reviewedOn: "Sep 5, 2024",
      showProgres: true,
      showBody: true,
      showFooter: true,
      btnTitle: "Explore",
      cardClassName: "",
      footerLineComp: "",
      btnAction: () => {
        console.log(
          `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
            SessionKeys.NEW_AI_ROLEPLAY_TOKEN
          )}&solution=aboca`
        );
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=aboca` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=aboca`,
          "_blank"
        );
      },
      descAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=aboca` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=aboca`,
          "_blank"
        );
      },
      bannerAction: () => {
        window.open(
          window.location.origin.includes("local") ||
            window.location.origin.includes("192.168") ||
            window.location.origin.includes("dev") ||
            window.location.origin.includes("stg") ||
            window.location.origin.includes("uat")
            ? `https://dev.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=aboca` //https://demo.infiniit.ai/xsel-roleplay/?
            : `https://demo.infiniit.ai/halifax-roleplay/login?token=${localStorage.getItem(
                SessionKeys.NEW_AI_ROLEPLAY_TOKEN
              )}&solution=aboca`,
          "_blank"
        );
      },
      priceInfo: {
        isFree: true,
        isPurchased: false,
        isAddToCart: false,
        isOffer: "",
        price: 0,
        offerPrice: 0,
        showText: "",
        textColor: "#292D32",
        teaserViewed: false,
        teaserAccessed: false,
      },
      isLoading: false,
      rightBtnIcon: <RightArrowIcon />,
      leftBtnIcon: "",
    },
  ]);

  // useEffect(() => {
  //   if (searchText?.length > 2) {
  //     fetchPersonalCoachListing(searchText);
  //   } else if (searchText?.length === 0) {
  //     fetchPersonalCoachListing("");
  //   }
  // }, [searchText]);

  const handleInputChange = (e) => {
    const text = e.target.value;
    setSearchText(text);

    if (timeoutId) {
      clearTimeout(timeoutId);
    }

    setTimeoutId(
      setTimeout(() => {
        setDebouncedText(text);
      }, 500)
    ); // adjust the delay as needed
  };

  useEffect(() => {
    if (debouncedText.length >= 3) {
      // Call API here
      fetchPersonalCoachListing(debouncedText);
    } else if (debouncedText.length === 0) {
      // Call API here if needed
      fetchPersonalCoachListing(debouncedText);
    }
  }, [debouncedText]);

  return (
    <section className="suggested-coaching">
      <div className="container-suge">
        <div className="row">
          <div className="col-12">
            <h3 className="mentor-title mb-0">{t("Coaches")}</h3>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-12">
            <div className="contsection">
              <Tabs
                id="controlled-tab-example"
                activeKey={key}
                onSelect={(k) => {
                  setKey(k);
                  if (k == "YourCoaches") {
                    fetchPersonalCoachListing();
                  } else {
                  }
                }}
              >
                <Tab eventKey={"YourCoaches"} title={t("yourCoaches")}>
                  <div className="inner-content-caoch pt-4">
                    <div className="s-earch-and-filters d-flex gap-3 justify-content-between mb-3 flex-wrap">
                      <div className="search-filter position-relative">
                        <input
                          type="search"
                          placeholder={t("Search")}
                          id="inputPassword2"
                          className="form-control"
                          disabled={isLoading}
                          value={searchText}
                          // onChange={(e) => {
                          //   // if (e.target.value.length >= 3) {
                          //   //   if (key === "YourCoaches") {
                          //   //     fetchPersonalCoachListing(e.target.value);
                          //   //   } else {
                          //   //   }
                          //   // } else if (e.target.value.length === 0) {
                          //   //   if (key === "YourCoaches") {
                          //   //     fetchPersonalCoachListing(e.target.value);
                          //   //   } else {
                          //   //   }
                          //   // }
                          //   setSearchText(e.target.value);
                          // }}
                          onChange={handleInputChange}
                        />
                        {false && (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            width="20"
                            height="20"
                            viewBox="0 0 20 20"
                            fill="none"
                            className="cursor-pointer"
                          >
                            <path
                              d="M19.6973 18.3984L14.4629 13.1641C15.5957 11.7969 16.2207 10.0391 16.2207 8.125C16.2207 3.67188 12.5489 0 8.09571 0C3.60352 0 0.00976562 3.67188 0.00976562 8.125C0.00976562 12.6172 3.64258 16.25 8.09571 16.25C9.97071 16.25 11.7286 15.625 13.1348 14.4922L18.3692 19.7266C18.5645 19.9219 18.7989 20 19.0723 20C19.3067 20 19.541 19.9219 19.6973 19.7266C20.0879 19.375 20.0879 18.7891 19.6973 18.3984ZM1.88477 8.125C1.88477 4.6875 4.65821 1.875 8.13477 1.875C11.5723 1.875 14.3848 4.6875 14.3848 8.125C14.3848 11.6016 11.5723 14.375 8.13477 14.375C4.65821 14.375 1.88477 11.6016 1.88477 8.125Z"
                              fill="black"
                            />
                          </svg>
                        )}
                      </div>
                      {myCoaches === "true" ? (
                        ""
                      ) : (
                        <div className="filter-section">
                          <div className="filter-option-listing d-flex justify-content-start gap-2 flex-wrap">
                            <div className="filter-btn">
                              <div className="position-relative">
                                <button
                                  className="btn btn-outline-primary w-100 dropdown-toggle"
                                  onClick={toggleIndustryDropdown}
                                  disabled={isLoading}
                                >
                                  {t("Industry")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </button>

                                {showIndustryDropdown && (
                                  <div
                                    className="border rounded bg-white p-3 filter-drop"
                                    // style={{
                                    //   position: "absolute",
                                    //   top: "100%",
                                    //   left: 0,
                                    //   zIndex: 1050,
                                    //   width: "250px",
                                    //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    // }}
                                  >
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Search..."
                                      value={industrySearch}
                                      onChange={handleIndustrySearchChange}
                                    />

                                    <div
                                      style={{
                                        maxHeight: "100px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {filteredIndustries?.length > 0 ? (
                                        filteredIndustries?.map((item) => (
                                          <div
                                            key={item?.id}
                                            className="form-check"
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={item}
                                              id={`checkbox-${item?.id}`}
                                              checked={selectedIndustryItems.includes(
                                                item?.id
                                              )}
                                              onChange={() =>
                                                handleIndustryCheckboxChange(
                                                  item?.id
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`checkbox-${item}`}
                                            >
                                              {item?.name}
                                            </label>
                                          </div>
                                        ))
                                      ) : (
                                        <p className="text-muted">
                                          {t("No items found")}
                                        </p>
                                      )}
                                    </div>

                                    <button
                                      className="btn btn-primary w-100 mt-2"
                                      onClick={handleIndustryApply}
                                      disabled={_.isEmpty(
                                        selectedIndustryItems
                                      )}
                                    >
                                      {t("Apply")}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="filter-btn">
                              <div className="position-relative">
                                <button
                                  className="btn btn-outline-primary w-100 dropdown-toggle"
                                  onClick={toggleLanguageDropdown}
                                  disabled={isLoading}
                                >
                                  {t("language")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </button>

                                {showLanguageDropdown && (
                                  <div
                                    className="border rounded bg-white p-3 filter-drop"
                                    // style={{
                                    //   position: "absolute",
                                    //   top: "100%",
                                    //   left: 0,
                                    //   zIndex: 1050,
                                    //   width: "200px",
                                    //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    // }}
                                  >
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Search..."
                                      value={languageSearch}
                                      onChange={handleLanguageSearchChange}
                                    />

                                    <div
                                      style={{
                                        maxHeight: "100px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {filteredLanguages?.length > 0 ? (
                                        filteredLanguages?.map((item) => (
                                          <div
                                            key={item?.id}
                                            className="form-check"
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={item}
                                              id={`checkbox-${item}`}
                                              checked={selectedLanguageItems.includes(
                                                item?.display_name
                                              )}
                                              onChange={() =>
                                                handleLanguageCheckboxChange(
                                                  item?.display_name
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`checkbox-${item?.id}`}
                                            >
                                              {item?.display_name}
                                            </label>
                                          </div>
                                        ))
                                      ) : (
                                        <p className="text-muted">
                                          {t("No items found")}
                                        </p>
                                      )}
                                    </div>

                                    <button
                                      className="btn btn-primary w-100 mt-2"
                                      onClick={handleLanguageApply}
                                      disabled={_.isEmpty(
                                        selectedLanguageItems
                                      )}
                                    >
                                      {t("Apply")}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="filter-btn">
                              <div className="position-relative">
                                <button
                                  className="btn btn-outline-primary w-100 dropdown-toggle"
                                  onClick={toggleCountryDropdown}
                                  disabled={isLoading}
                                >
                                  {t("Country")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </button>

                                {showCountryDropdown && (
                                  <div
                                    className="border rounded bg-white p-3 filter-drop"
                                    // style={{
                                    //   position: "absolute",
                                    //   top: "100%",
                                    //   left: 0,
                                    //   zIndex: 1050,
                                    //   width: "200px",
                                    //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    // }}
                                  >
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Search..."
                                      value={countrySearch}
                                      onChange={handleCountrySearchChange}
                                    />

                                    <div
                                      style={{
                                        maxHeight: "100px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {filteredCountries?.length > 0 ? (
                                        filteredCountries?.map((item) => (
                                          <div
                                            key={item?.id}
                                            className="form-check"
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={item}
                                              id={`checkbox-${item?.id}`}
                                              checked={selectedCountryItems.includes(
                                                item?.id
                                              )}
                                              onChange={() =>
                                                handleCountryCheckboxChange(
                                                  item?.id
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`checkbox-${item}`}
                                            >
                                              {item?.name}
                                            </label>
                                          </div>
                                        ))
                                      ) : (
                                        <p className="text-muted">
                                          {t("No items found")}
                                        </p>
                                      )}
                                    </div>

                                    <button
                                      className="btn btn-primary w-100 mt-2"
                                      onClick={handleCountryApply}
                                      disabled={_.isEmpty(selectedCountryItems)}
                                    >
                                      {t("Apply")}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>

                            <div className="filter-btn">
                              <div className="position-relative">
                                <button
                                  className="btn btn-outline-primary w-100 dropdown-toggle"
                                  onClick={toggleRatingDropdown}
                                  disabled={isLoading}
                                >
                                  {t("Rating")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </button>

                                {showRatingDropdown && (
                                  <>
                                    <div
                                      className="border rounded bg-white p-3 filter-drop"
                                      // style={{
                                      //   position: "absolute",
                                      //   top: "100%",
                                      //   left: 0,
                                      //   zIndex: 1050,
                                      //   width: "200px",
                                      //   boxShadow:
                                      //     "0 4px 6px rgba(0, 0, 0, 0.1)",
                                      // }}
                                    >
                                      {range ? (
                                        <p>
                                          {t("Currently")}: {range[0]} -{" "}
                                          {range[1]}
                                        </p>
                                      ) : (
                                        ""
                                      )}

                                      <Slider
                                        range
                                        min={0}
                                        max={5}
                                        step={1}
                                        defaultValue={range}
                                        value={range}
                                        onChange={handleRangeChange}
                                        allowCross={false}
                                        trackStyle={[
                                          {
                                            backgroundColor: "#87CEEB",
                                            height: 6,
                                          },
                                        ]}
                                        handleStyle={[
                                          {
                                            backgroundColor: "#87CEEB",
                                            borderColor: "#87CEEB",
                                          },
                                          {
                                            backgroundColor: "#87CEEB",
                                            borderColor: "#87CEEB",
                                          },
                                        ]}
                                        railStyle={{
                                          backgroundColor: "#ddd",
                                          height: 6,
                                        }}
                                        tipFormatter={(value) => `${value}`}
                                      />
                                      <button
                                        className="btn btn-primary w-100 mt-2"
                                        onClick={handleRatingApply}
                                      >
                                        {t("Apply")}
                                      </button>
                                    </div>
                                  </>
                                )}
                              </div>
                            </div>
                            <div className="filter-btn">
                              <div className="position-relative">
                                <button
                                  className="btn btn-outline-primary w-100 dropdown-toggle"
                                  onClick={toggleSkillDropdown}
                                  disabled={isLoading}
                                >
                                  {t("skills")}
                                  <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="10"
                                    viewBox="0 0 20 10"
                                    fill="none"
                                  >
                                    <path
                                      d="M18.9587 1.78879L10.7517 9.65205C10.4939 9.86695 10.236 9.95285 10.0212 9.95285C9.7634 9.95285 9.50559 9.86695 9.29074 9.69505L1.04074 1.78879C0.611052 1.40207 0.611052 0.714569 0.99777 0.327849C1.38449 -0.101839 2.07199 -0.101839 2.45871 0.284879L10.0212 7.50363L17.5407 0.284879C17.9274 -0.101839 18.615 -0.101839 19.0017 0.327849C19.3884 0.714569 19.3884 1.40207 18.9587 1.78879Z"
                                      fill="#2D2D2D"
                                    />
                                  </svg>
                                </button>

                                {showSkillDropdown && (
                                  <div
                                    className="border rounded bg-white p-3 filter-drop"
                                    // style={{
                                    //   position: "absolute",
                                    //   top: "100%",
                                    //   left: 0,
                                    //   zIndex: 1050,
                                    //   width: "200px",
                                    //   boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                                    // }}
                                  >
                                    <input
                                      type="text"
                                      className="form-control mb-2"
                                      placeholder="Search..."
                                      value={skillSearch}
                                      onChange={handleSkillSearchChange}
                                    />

                                    <div
                                      style={{
                                        maxHeight: "100px",
                                        overflowY: "auto",
                                      }}
                                    >
                                      {filteredSkills?.length > 0 ? (
                                        filteredSkills?.map((item) => (
                                          <div
                                            key={item?.id}
                                            className="form-check"
                                          >
                                            <input
                                              className="form-check-input"
                                              type="checkbox"
                                              value={item}
                                              id={`checkbox-${item?.id}`}
                                              checked={selectedSkillItems.includes(
                                                item?.id
                                              )}
                                              onChange={() =>
                                                handleSkillCheckboxChange(
                                                  item?.id
                                                )
                                              }
                                            />
                                            <label
                                              className="form-check-label"
                                              htmlFor={`checkbox-${item}`}
                                            >
                                              {item?.name}
                                            </label>
                                          </div>
                                        ))
                                      ) : (
                                        <p className="text-muted">
                                          {t("No items found")}
                                        </p>
                                      )}
                                    </div>

                                    <button
                                      className="btn btn-primary w-100 mt-2"
                                      onClick={handleSkillApply}
                                      disabled={_.isEmpty(selectedSkillItems)}
                                    >
                                      {t("Apply")}
                                    </button>
                                  </div>
                                )}
                              </div>
                            </div>

                            {!_.isEmpty(languages) ||
                            !_.isEmpty(rating) ||
                            !_.isEmpty(skills) ||
                            !_.isEmpty(industries) ||
                            !_.isEmpty(countries) ? (
                              <div className="filter-btn">
                                <div className="position-relative">
                                  <button
                                    className="w-100 reset-buttonc"
                                    onClick={handleResetAllFilters}
                                    disabled={isLoading}
                                  >
                                    {t("Reset All")}
                                  </button>
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        </div>
                      )}
                    </div>
                    <div className="councoa d-flex justify-content-start mb-3">
                      {isLoading ? (
                        <ShimmerScreen
                          case="rect"
                          width="10rem"
                          height="2.25rem"
                        />
                      ) : (
                        !_.isEmpty(coachList) && (
                          <p>
                            {t("We found")} {coachList?.length}{" "}
                            {coachList?.length > 1 ? t("coaches") : t("coach")}
                          </p>
                        )
                      )}
                    </div>
                    <div className="row coach-list g-xxl-5 g-4">
                      {!_.isEmpty(coachList) ? (
                        coachList?.map((item, i) => {
                          console.log("check000", item);
                          return (
                            <ProductCardComponent
                              {...item}
                              key={`course-${i + 1}`}
                              lastKey={coachList?.length === i + 1}
                              refInfo={paginateCB}
                            />
                          );
                          // return (
                          //   <div
                          //     className="col-md-6 col-lg-4 col-md-6"
                          //     ref={paginateCB}
                          //   >
                          //     <div className="coach-box">
                          //       <div className="above-info">
                          //         <div className="img-box-caoch">
                          //           <img
                          //             src={
                          //               item?.profile_image
                          //                 ? item?.profile_image
                          //                 : "https://cdnstg.training.com/halifax/image/10543/2058509172-20241212.png"
                          //             }
                          //             className="img-fluid"
                          //             alt=""
                          //           />
                          //           <div className="overlay-box-ino d-flex justify-content-between">
                          //             {!_.isEmpty(item?.user_industry) && (
                          //               <div className="infobox">
                          //                 {item?.user_industry[0]}
                          //               </div>
                          //             )}
                          //             {!_.isEmpty(item?.experience) && (
                          //               <div className="infobox">
                          //                 <svg
                          //                   xmlns="http://www.w3.org/2000/svg"
                          //                   width="14"
                          //                   height="15"
                          //                   viewBox="0 0 14 15"
                          //                   fill="none"
                          //                 >
                          //                   <g clip-path="url(#clip0_935_21063)">
                          //                     <path
                          //                       d="M2.04761 10.502V14.6625H11.8704V10.502H2.04761Z"
                          //                       fill="#4D5E80"
                          //                     />
                          //                     <path
                          //                       d="M6.95898 10.502H11.8704V14.6625H6.95898V10.502Z"
                          //                       fill="#3D4566"
                          //                     />
                          //                     <path
                          //                       d="M6.5498 10.979H7.36838V12.2069H6.5498V10.979Z"
                          //                       fill="#FFDF40"
                          //                     />
                          //                     <path
                          //                       d="M6.95898 10.979H7.36827V12.2069H6.95898V10.979Z"
                          //                       fill="#FFBE40"
                          //                     />
                          //                     <path
                          //                       d="M9.00545 7.70463H8.18688V6.74502C7.91274 6.63658 7.42902 6.47677 6.95902 6.47677C6.48914 6.47677 6.0055 6.6365 5.73117 6.74505V7.70463H4.9126V6.22381L5.13885 6.11068C5.1758 6.09221 6.05423 5.6582 6.95902 5.6582C7.86381 5.6582 8.74225 6.09221 8.77919 6.11068L9.00545 6.22381V7.70463Z"
                          //                       fill="#4D5E80"
                          //                     />
                          //                     <path
                          //                       d="M8.18684 6.74502V7.70463H9.00541V6.22381L8.77916 6.11068C8.74221 6.09221 7.86378 5.6582 6.95898 5.6582V6.47677C7.42898 6.47677 7.9127 6.63658 8.18684 6.74502Z"
                          //                       fill="#3D4566"
                          //                     />
                          //                     <path
                          //                       d="M11.8704 7.29541V10.502L6.95903 11.3951L2.04761 10.502V7.29541H11.8704Z"
                          //                       fill="#3D4566"
                          //                     />
                          //                     <path
                          //                       d="M11.8704 7.29541H6.95898V11.3951L11.8704 10.502V7.29541Z"
                          //                       fill="#2E2E4D"
                          //                     />
                          //                     <path
                          //                       d="M3.57527 6.55573L2.20965 6.12819L0.844027 6.55573L0.828638 5.12484L0 3.95816L1.35612 3.50135L2.20965 2.35278L3.06317 3.50135L4.41929 3.95816L3.59068 5.12484L3.57527 6.55573Z"
                          //                       fill="#FFDF40"
                          //                     />
                          //                     <path
                          //                       d="M5.59351 4.91852L5.57812 3.48764L4.74951 2.32096L6.10564 1.86414L6.95916 0.715576L7.81265 1.86414L9.16878 2.32096L8.34017 3.48764L8.32481 4.91855L6.95916 4.49101L5.59351 4.91852Z"
                          //                       fill="#FFDF40"
                          //                     />
                          //                     <path
                          //                       d="M13.1561 6.55576L11.7904 6.12822L10.4248 6.55576L10.4094 5.12484L9.58081 3.95816L10.9369 3.50135L11.7904 2.35278L12.6439 3.50135L14 3.95816L13.1714 5.12484L13.1561 6.55576Z"
                          //                       fill="#FFDF40"
                          //                     />
                          //                     <path
                          //                       d="M8.32463 4.91852L8.33999 3.48761L9.1686 2.32096L7.81248 1.86414L6.95898 0.715576V4.49098L8.32463 4.91852Z"
                          //                       fill="#FFBE40"
                          //                     />
                          //                     <path
                          //                       d="M13.1559 6.55573L13.1713 5.12484L13.9999 3.95816L12.6438 3.50135L11.7903 2.35278V6.12819L13.1559 6.55573Z"
                          //                       fill="#FFBE40"
                          //                     />
                          //                     <path
                          //                       d="M3.57536 6.55573L3.59075 5.12484L4.41936 3.95816L3.06324 3.50135L2.20972 2.35278V6.12819L3.57536 6.55573Z"
                          //                       fill="#FFBE40"
                          //                     />
                          //                   </g>
                          //                   <defs>
                          //                     <clipPath id="clip0_935_21063">
                          //                       <rect
                          //                         width="14"
                          //                         height="14"
                          //                         fill="white"
                          //                         transform="translate(0 0.688965)"
                          //                       />
                          //                     </clipPath>
                          //                   </defs>
                          //                 </svg>{" "}
                          //                 Exp {item?.experience}
                          //               </div>
                          //             )}
                          //           </div>
                          //         </div>

                          //         <div className="caoch-info">
                          //           <div className="flex">
                          //             <h4 className="coach-tiele">
                          //               {item?.display_name}
                          //             </h4>
                          //             <div className="coach-desx">
                          //               {/* <p
                          //               dangerouslySetInnerHTML={{
                          //                 __html: item?.bio,
                          //               }}
                          //             ></p> */}
                          //               <p>
                          //                 {item?.user_skill?.map(
                          //                   (skill, index) => {
                          //                     console.log(
                          //                       "check---",
                          //                       item,
                          //                       index
                          //                     );
                          //                     if (
                          //                       _.toNumber(
                          //                         item?.user_skill.length - 1
                          //                       ) === _.toNumber(index)
                          //                     ) {
                          //                       return skill;
                          //                     } else {
                          //                       return `${skill},${" "}`;
                          //                     }
                          //                   }
                          //                 )}
                          //               </p>
                          //               {false && (
                          //                 <span
                          //                   className="readmore"
                          //                   onClick={() =>
                          //                     navigate("/coach/detail")
                          //                   }
                          //                 >
                          //                   Read more...
                          //                 </span>
                          //               )}
                          //             </div>
                          //             {false && (
                          //               <div className="key-skills-coach">
                          //                 <p>
                          //                   <strong>{t("keySkills")}</strong>
                          //                 </p>
                          //                 <p>
                          //                   {item?.product_skills.map(
                          //                     (name, index) =>
                          //                       item?.product_skills.length ===
                          //                       1
                          //                         ? `${name}`
                          //                         : item?.product_skills
                          //                             .length ===
                          //                           index + 1
                          //                         ? `${name}`
                          //                         : `${name}, `
                          //                   )}
                          //                 </p>
                          //               </div>
                          //             )}
                          //             {(item?.linkedIn || item?.twitter) &&
                          //               false && (
                          //                 <div className="socliwra">
                          //                   <p>
                          //                     <strong>
                          //                       {t("portfolio")}/
                          //                       {t("profileLink")}
                          //                     </strong>
                          //                   </p>
                          //                   <div className="socililink-caoc">
                          //                     {item?.linkedIn && (
                          //                       <div className="socl-icon">
                          //                         <svg
                          //                           xmlns="http://www.w3.org/2000/svg"
                          //                           width="24"
                          //                           height="25"
                          //                           viewBox="0 0 24 25"
                          //                           fill="none"
                          //                         >
                          //                           <g clip-path="url(#clip0_935_21044)">
                          //                             <path
                          //                               d="M21.829 0.688965H2.17099C0.972 0.688965 0 1.66096 0 2.85996V22.5179C0 23.717 0.972 24.689 2.17099 24.689H21.8289C23.028 24.689 24 23.717 24 22.5179V2.85996C24 1.66096 23.028 0.688965 21.829 0.688965ZM7.42662 21.4121C7.42662 21.7611 7.14377 22.0439 6.79483 22.0439H4.10544C3.7565 22.0439 3.47365 21.7611 3.47365 21.4121V10.1384C3.47365 9.78942 3.7565 9.50658 4.10544 9.50658H6.79483C7.14377 9.50658 7.42662 9.78942 7.42662 10.1384V21.4121ZM5.45014 8.44385C4.0391 8.44385 2.8952 7.29996 2.8952 5.88892C2.8952 4.47789 4.0391 3.33399 5.45014 3.33399C6.86117 3.33399 8.00507 4.47789 8.00507 5.88892C8.00507 7.29996 6.86124 8.44385 5.45014 8.44385ZM21.4813 21.463C21.4813 21.7838 21.2212 22.0439 20.9004 22.0439H18.0145C17.6937 22.0439 17.4335 21.7838 17.4335 21.463V16.175C17.4335 15.3861 17.6649 12.7182 15.372 12.7182C13.5934 12.7182 13.2327 14.5443 13.1602 15.3638V21.463C13.1602 21.7838 12.9002 22.0439 12.5793 22.0439H9.78817C9.46737 22.0439 9.20727 21.7838 9.20727 21.463V10.0875C9.20727 9.76668 9.46737 9.50658 9.78817 9.50658H12.5793C12.9001 9.50658 13.1602 9.76668 13.1602 10.0875V11.071C13.8197 10.0813 14.7998 9.3174 16.8866 9.3174C21.5077 9.3174 21.4813 13.6346 21.4813 16.0067V21.463Z"
                          //                               fill="#0077B7"
                          //                             />
                          //                           </g>
                          //                           <defs>
                          //                             <clipPath id="clip0_935_21044">
                          //                               <rect
                          //                                 width="24"
                          //                                 height="24"
                          //                                 fill="white"
                          //                                 transform="translate(0 0.688965)"
                          //                               />
                          //                             </clipPath>
                          //                           </defs>
                          //                         </svg>
                          //                       </div>
                          //                     )}
                          //                     {item?.twitter && (
                          //                       <div className="socl-icon">
                          //                         <svg
                          //                           xmlns="http://www.w3.org/2000/svg"
                          //                           width="24"
                          //                           height="25"
                          //                           viewBox="0 0 24 25"
                          //                           fill="none"
                          //                         >
                          //                           <g clip-path="url(#clip0_935_21046)">
                          //                             <path
                          //                               d="M12.8025 12.2793L18.2033 20.0045H15.9868L11.5796 13.7007V13.7003L10.9325 12.7749L5.78418 5.41064H8.00071L12.1554 11.3539L12.8025 12.2793Z"
                          //                               fill="black"
                          //                             />
                          //                             <path
                          //                               d="M21.4067 0.688965H2.59325C1.16108 0.688965 0 1.85004 0 3.28222V22.0957C0 23.5279 1.16108 24.689 2.59325 24.689H21.4067C22.8389 24.689 24 23.5279 24 22.0957V3.28222C24 1.85004 22.8389 0.688965 21.4067 0.688965ZM15.308 21.0414L10.8481 14.5507L5.26435 21.0414H3.82122L10.2073 13.6185L3.82122 4.32417H8.69203L12.9152 10.4705L18.2026 4.32417H19.6458L13.5562 11.4029H13.5558L20.1788 21.0414H15.308Z"
                          //                               fill="black"
                          //                             />
                          //                           </g>
                          //                           <defs>
                          //                             <clipPath id="clip0_935_21046">
                          //                               <rect
                          //                                 width="24"
                          //                                 height="24"
                          //                                 fill="white"
                          //                                 transform="translate(0 0.688965)"
                          //                               />
                          //                             </clipPath>
                          //                           </defs>
                          //                         </svg>
                          //                       </div>
                          //                     )}
                          //                   </div>
                          //                 </div>
                          //               )}
                          //           </div>
                          //         </div>
                          //       </div>
                          //       <div className="foddd w-100">
                          //         <div className="key-skills-coach">
                          //           <p>
                          //             <strong>{t("Ratings")}</strong>
                          //           </p>
                          //           <div className="d-flex align-items-center gap-3">
                          //             <div>
                          //               <strong>{item?.ratings}</strong>
                          //             </div>
                          //             <div>
                          //               <Rating
                          //                 name="half-rating"
                          //                 value={item?.ratings}
                          //                 precision={0.5}
                          //                 readOnly={true}
                          //               />
                          //             </div>
                          //           </div>
                          //         </div>
                          //         <div className="caouch-bntfp">
                          //           <div className="d-flex footer-btn-card justify-content-between align-items-center gap-1">
                          //             <div className="price-sec-xl">
                          //               <span className="signup-btn offer-price-com enroled">
                          //                 <span>
                          //                   {!_.isEmpty(item?.priceInfo)
                          //                     ? ProductCardPriceInfo(
                          //                         item?.priceInfo.showText,
                          //                         item?.priceInfo.textColor
                          //                       )
                          //                     : ""}
                          //                 </span>
                          //               </span>
                          //             </div>
                          //             <button
                          //               type="button"
                          //               className="startcourse-btn"
                          //               // onClick={item?.btnAction}
                          //               onClick={() => {
                          //                 if (item?.priceInfo?.isPurchased) {
                          //                   // alert('Feature under development')
                          //                   // setActiveTab("thisWeek");
                          //                   setSelectedCoachId(item?.user_id);
                          //                   setProductTitle(
                          //                     item?.product_title
                          //                   );
                          //                   setProductId(item?.product_id);
                          //                   setDisplayName(item?.display_name);
                          //                   // setActiveSlot(null);
                          //                   setSessionModal(true);
                          //                 } else {
                          //                   // proceedToPurchase(
                          //                   //   item?.data,
                          //                   //   item?.priceInfo
                          //                   // );
                          //                   handleCoachDetailNavigate(
                          //                     item?.user_id
                          //                   );
                          //                 }
                          //               }}
                          //             >
                          //               {item?.priceInfo?.isPurchased
                          //                 ? t("RequestForASession")
                          //                 : t("proceed")}{" "}
                          //               <svg
                          //                 xmlns="http://www.w3.org/2000/svg"
                          //                 width="20"
                          //                 height="20"
                          //                 viewBox="0 0 20 20"
                          //                 fill="none"
                          //               >
                          //                 <path
                          //                   d="M4.16602 9.99981H15.8327M15.8327 9.99981L9.99935 4.16648M15.8327 9.99981L9.99935 15.8331"
                          //                   stroke="#415385"
                          //                   stroke-width="1.66667"
                          //                   stroke-linecap="round"
                          //                   stroke-linejoin="round"
                          //                 ></path>
                          //               </svg>
                          //             </button>
                          //           </div>
                          //         </div>
                          //       </div>
                          //     </div>
                          //   </div>
                          // );
                        })
                      ) : (
                        <NotFoundComponent
                          width={200}
                          height={219}
                          showBtn={false}
                          showMsg={true}
                          msgLine={t("No Coach Found!")}
                        />
                      )}
                    </div>
                  </div>
                </Tab>
                {localStorage.getItem(SessionKeys.NEW_AI_ROLEPLAY_TOKEN) &&
                  false && (
                    <Tab eventKey={"AI"} title="AI Coach">
                      <div className="mt-5">
                        <div className="row coach-list g-xxl-5 g-4">
                          {formattedListing.length > 0 ? (
                            formattedListing.map((v, i) => {
                              return (
                                <ProductCardComponent
                                  {...v}
                                  show4={false}
                                  // key={`roleplay-${i + 1}`}
                                  cardClassName="videocard"
                                  lastKey={false}
                                  refInfo=""
                                />
                              );
                            })
                          ) : (
                            <NotFoundComponent
                              width={400}
                              height={419}
                              showBtn={false}
                              showMsg={true}
                              msgLine={"Nothing here, yet."}
                            />
                          )}
                        </div>
                      </div>
                    </Tab>
                  )}
              </Tabs>
            </div>
          </div>
        </div>
      </div>
      {sessionModal && (
        <SlotBookingModal
          sessionModal={sessionModal}
          setSessionModal={setSessionModal}
          selectedCoachId={selectedCoachId}
          setIsLoading={setIsLoading}
          productTitle={productTitle}
          productId={productId}
          displayName={displayName}
        />
      )}
    </section>
  );
};

export default CoachingListing;
